import React from 'react';
import { Row, Col, Form, InputNumber, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { useMutation } from '@apollo/client';

import { getSymbolFromCurrency } from '~helpers/currency';
import { MUTATION_UPDATE_COMMISSION_CREDIT_NOTE } from '../../queries';

import Modal from 'common/components/modal';

const useStyles = makeStyles(() => ({
  wrapper: {
    '& .ant-modal-header': {
      padding: '32px 32px 24px 32px',
    },
    '& .ant-modal-body': {
      padding: '0px 32px 8px',
    },

    '& .ant-form-item-label': {
      lineHeight: '22px',
      marginBottom: 8,
    },
  },
}));

const EditCreditNoteModal = ({
  form,
  refetchData,
  orderInfo,
  visible = false,
  setVisible = () => {},
}) => {
  const { getFieldDecorator, validateFields } = form;
  const classes = useStyles();
  const { t } = useTranslation();

  const handleCancelModal = () => {
    setVisible(false);
  };

  const [updateOrderCommissionCreditNote, { loading: updateLoading }] = useMutation(
    MUTATION_UPDATE_COMMISSION_CREDIT_NOTE,
    {
      fetchPolicy: 'network-only',
      onCompleted: res => {
        if (res?.updateOrderCommissionCreditNote?.orderCommission?.id) {
          refetchData?.();
          handleCancelModal();
        }
      },
    },
  );

  const handleConfirmClick = () => {
    validateFields((err, values) => {
      if (!err) {
        const { creditNoteNumber, creditNoteAmount } = values;
        const params = {
          id: orderInfo?.commission?.id,
          creditNoteNumber,
          creditNoteAmount: String(creditNoteAmount),
        };

        updateOrderCommissionCreditNote({
          variables: {
            input: params,
          },
        });
      }
    });
  };

  return (
    <Modal
      width={446}
      visible={visible}
      title={t('cms.reconciliation.lead_generation.update.modal.commission.title')}
      okText={t('cms.reconciliation.lead_generation.update.modal.ok_btn')}
      wrapClassName={classes.wrapper}
      onCancel={handleCancelModal}
      onOk={handleConfirmClick}
      okButtonProps={{
        loading: updateLoading,
      }}
      destroyOnClose={true}
    >
      <Form>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label={t('cms.reconciliation.lead_generation.update.modal.credit_note_number')}
            >
              {getFieldDecorator('creditNoteNumber', {
                initialValue: orderInfo?.commission?.creditNoteNumber ?? null,
                rules: [
                  {
                    validator: (_, value, callback) => {
                      value ? callback() : callback('Please enter the valid credit note number.');
                    },
                  },
                ],
              })(<Input placeholder="Please enter the credit note number." />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('cms.reconciliation.lead_generation.update.modal.credit_note_amount')}
            >
              {getFieldDecorator('creditNoteAmount', {
                initialValue: orderInfo?.commission?.creditNoteAmount ?? null,
                rules: [
                  {
                    type: 'number',
                    validator: (_, value, callback) => {
                      value ? callback() : callback('Please enter the valid credit note number.');
                    },
                  },
                ],
              })(
                <InputNumber
                  formatter={value =>
                    value
                      ? `${getSymbolFromCurrency(orderInfo?.order?.currency)} ${value}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ',',
                        )
                      : undefined
                  }
                  parser={value => value.replace(/[^0-9.]/g, '')}
                  min={0}
                  precision={2}
                  placeholder="Please enter the credit note amount."
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Form.create({
  name: 'edit-credit-note-modal',
})(EditCreditNoteModal);
